import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Philosophy',
    href: '#philosophy'
  }, {
    name: 'Expertise',
    href: '#expertise'
  }, {
    name: 'Work',
    href: '#work'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1]
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-primary/95 backdrop-blur-md border-b-2 border-accent py-4' : 'bg-transparent py-6'}`} aria-label="Main Navigation" data-id="element-92">
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-between" data-id="element-93">
        <a href="#top" className="font-serif text-xl tracking-wide text-text-primary hover:text-accent transition-colors" aria-label="Home" data-id="element-94">
          Sarah Jenkins<span className="text-accent" data-id="element-95">.</span>
        </a>
        <div className="hidden md:flex items-center space-x-8" data-id="element-96">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-semibold text-text-secondary hover:text-accent transition-colors" data-id="element-97">
              {link.name}
            </a>)}
        </div>
      </div>
    </motion.nav>;
}